<template>
  <v-app>
    <NavBar v-if="showNavbar" />
    <v-main>
      <div :id="$route.path === '/MainMenu' ? 'grad' : null">
        <router-view />
      </div>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  
  mounted() {
    this.checkInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token }).catch(() => {});
      }
    }, 60 * 1000);
  },

  computed: {
    showNavbar() {
      const routes = [
        "/Main",
        "/MainMenu",
        "/ManagePreRegister",
        "/ManageUser",
        "/ManageRole",
        "/PreRegister"
      ];

      return routes.includes(this.$route.path);
    },
  },

  beforeDestroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
};
</script>

<style>
@font-face {
  font-family: "English";
  src: local("English"), url(./assets/Font/Kanit-Regular.ttf);
}

.v-content__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 959px) {
  .v-content__wrap {
    background-color: white;
    width: 80%;
  }
}
* {
  font-family: "English";
}

#app {
  color: #444444;
}

#grad {
    height: 200px;
    background: #78A3D4;
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF);
    background: -moz-linear-gradient(#78A3D4, #FFF);
    background: linear-gradient(#78A3D4, #FFF);
}

::-webkit-scrollbar {
  display: none;
}
</style>
